type MarkerKind = 'dot' | 'pin' | 'selected';

const getMarkerKind = (
  meetingCount: number,
  isSelected: boolean
): MarkerKind => {
  if (isSelected) return 'selected';
  return meetingCount > 1 ? 'pin' : 'dot';
};

const getMarkerAltText = (meetings: { name: string }[]): string =>
  meetings.length > 0
    ? `Meeting pin for ${meetings.map((meeting) => meeting.name).join(', ')}`
    : 'Meeting pin';

export { getMarkerKind, getMarkerAltText };
export type { MarkerKind };
